class EngravingForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.prefillFromUrl();
    this.bindContentType();
    this.bindOtherToggles();
    this.bindPrevzem();
    this.bindBillingToggle();
    this.bindSubmit();
  }

  prefillFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const map = {
      product: 'product',
      variant: 'variant',
      sku: 'sku',
      url: 'url',
      variant_title: 'variant_title'
    };

    let hasProduct = false;

    Object.keys(map).forEach((key) => {
      const value = params.get(key);
      const input = this.querySelector(`[data-engrave-field="${map[key]}"]`);
      if (input && value) {
        input.value = value;
        hasProduct = true;
      }
    });

    if (hasProduct) {
      const box = this.querySelector('[data-engrave-prefill]');
      const titleEl = this.querySelector('[data-engrave-prefill-title]');
      const productParam = params.get('product') || '';
      const variantTitle = params.get('variant_title') || '';
      if (box && titleEl) {
        titleEl.textContent = variantTitle ? `${productParam} — ${variantTitle}` : productParam;
        box.hidden = false;
      }

      const modelField = this.querySelector('#ZiEngraveModel');
      if (modelField && !modelField.value) {
        modelField.value = productParam;
      }
    }
  }

  toggleGroup(selector, show) {
    this.querySelectorAll(selector).forEach((el) => {
      el.hidden = !show;
      el.querySelectorAll('input, textarea, select').forEach((field) => {
        field.disabled = !show;
        if (!show) {
          field.required = false;
        }
      });
    });
  }

  setRequired(selector, isRequired) {
    this.querySelectorAll(selector).forEach((field) => {
      field.required = isRequired;
    });
  }

  bindContentType() {
    const radios = this.querySelectorAll('[data-engrave="content-type"] input[type="radio"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        const value = radio.dataset.engraveValue || '';
        const showText = value.includes('text');
        const showLogo = value.includes('logo');

        this.toggleGroup('[data-engrave-show="text"]', showText);
        this.toggleGroup('[data-engrave-show="logo"]', showLogo);
        this.setRequired('[data-engrave-show="text"] #ZiEngraveText', showText);
      });
    });
  }

  bindOtherToggles() {
    this.querySelectorAll('[data-engrave-other-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const key = select.dataset.engraveOtherSelect;
        const targetField = this.querySelector(`[data-engrave-other-field="${key}"]`);
        if (targetField) {
          const show = select.value === 'Drugo';
          targetField.hidden = !show;
          targetField.querySelectorAll('input, textarea').forEach((f) => { f.disabled = !show; });
        }
      });
    });
  }

  bindPrevzem() {
    const radios = this.querySelectorAll('[data-engrave="prevzem"] input[type="radio"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        const showDostava = radio.dataset.engraveValue === 'dostava' && radio.checked;
        this.toggleGroup('[data-engrave-show="dostava"]', showDostava);
        this.setRequired('[data-engrave-show="dostava"] #ZiEngraveRecipientAddress, [data-engrave-show="dostava"] #ZiEngraveRecipientZip, [data-engrave-show="dostava"] #ZiEngraveRecipientCity', showDostava);
      });
    });
  }

  bindBillingToggle() {
    const toggle = this.querySelector('[data-engrave="billing-toggle"]');
    if (!toggle) return;
    toggle.addEventListener('change', () => {
      this.toggleGroup('[data-engrave-show="billing"]', toggle.checked);
    });
  }

  bindSubmit() {
    const button = this.querySelector('[data-engrave-submit]');
    const label = this.querySelector('[data-engrave-submit-label]');
    if (!button || !this.form) return;

    this.form.addEventListener('submit', () => {
      if (button.disabled) return;
      button.disabled = true;
      if (label) label.textContent = 'Pošiljanje ...';
    });
  }
}

customElements.define('engraving-form', EngravingForm);
